"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var utils_1 = require("../utils");
function useCountClicks(_a) {
    var _b = _a === void 0 ? {
        track: function () { },
    } : _a, track = _b.track, trackingMessage = _b.trackingMessage, trackingProps = _b.trackingProps;
    var clicksRef = react_1.useRef(0);
    function incrementClicks() {
        clicksRef.current += 1;
    }
    function onComponentUnmount() {
        var message = trackingMessage || 'track click';
        track(message, __assign(__assign({}, (trackingProps || {})), { number_of_clicks_on_refresh_close_or_navigate_away: clicksRef.current }));
        window.removeEventListener('click', incrementClicks);
        window.removeEventListener('beforeunload', onComponentUnmount);
    }
    var onComponentUnmountCallback = react_1.useCallback(onComponentUnmount, []);
    react_1.useEffect(function () {
        if (utils_1.isBrowser()) {
            window.addEventListener('click', incrementClicks);
            window.addEventListener('beforeunload', onComponentUnmountCallback);
        }
        // will be called on component unmount
        return function () {
            if (utils_1.isBrowser()) {
                onComponentUnmountCallback();
            }
        };
    }, [onComponentUnmountCallback]);
}
exports.default = useCountClicks;
